import { render, staticRenderFns } from "./FichaIncidencias.vue?vue&type=template&id=97e399ce"
import script from "./FichaIncidencias.vue?vue&type=script&lang=js"
export * from "./FichaIncidencias.vue?vue&type=script&lang=js"
import style0 from "./FichaIncidencias.vue?vue&type=style&index=0&id=97e399ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports